import Bugsnag from "@bugsnag/js";

const NOT_FOUND = 404;
const GONE = 410;

export const debugLoadingGifs = (error: any) => {
  const status = error?.response?.status;
  const code = error?.code;

  if (status === NOT_FOUND || status === GONE) {
    return;
  }

  if (code === "ERR_CANCELED" || code === "ERR_NETWORK" || code === "ECONNABORTED") {
    return;
  }

  return Bugsnag.notify(
    new Error("Error loading gif error"),
    event => {
      event.context = "LOADING_GIFS_ERROR";
      event.addMetadata("Error", {
        pageUrl: window.location.href,
        // @ts-ignore
        message: error?.message,
        // @ts-ignore
        status,
        // @ts-ignore
        code,
        // @ts-ignore
        responseData: JSON.stringify(error?.response?.data)
      });
    }
  );
};
